"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _index = _interopRequireDefault(require("../../Button/index"));

var _FeedbackNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/FeedbackNugget"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _KesiConstants = require("../../../../KESI2/KesiConstants");

var _KESI2Helper = require("../../../../KESI2/KESI2Helper");

var _Nugget = _interopRequireDefault(require("./Nugget.scss"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../../KESI2/KESI2BasicComponent"));

var _DrupalFeedbackNugget = _interopRequireDefault(require("./DrupalFeedbackNugget.scss"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _DrupalNuggetStrings = require("./DrupalNuggetStrings");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DrupalFormNugget = _interopRequireDefault(require("./DrupalFormNugget"));

var _MailHelper = require("../../../../helpers/MailHelper");

var _core = require("@material-ui/core");

var _MuiAlertHelper = require("../../../../helpers/MuiAlertHelper");

var _UserManagementService = _interopRequireDefault(require("../../Equizzer/services/UserManagementService"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DOM_PREFIX = 'feedbackContainer_';
var StyledTextField = (0, _core.withStyles)({
  root: {
    '& label.Mui-focused': {
      color: _cssConstants["default"].colors.buttonBackground
    },
    '& .MuiFormLabel-root': {
      maxWidth: 'calc(100% - 28px)'
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: _cssConstants["default"].colors.buttonBackground
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: _cssConstants["default"].colors.buttonBackground
      },
      '&.Mui-focused fieldset': {
        borderColor: _cssConstants["default"].colors.buttonBackground
      }
    }
  }
})(_TextField["default"]);

var DrupalFeedbackNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalFeedbackNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalFeedbackNugget);

  function DrupalFeedbackNugget(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, DrupalFeedbackNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "handleChange", function (event) {
      if (event && event.target) {
        _this.setState({
          value: event.target.value
        });
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "handleSubjectChange", function (event) {
      if (event && event.target) {
        _this.setState({
          subjectValue: event.target.value
        });
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onClick", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var valueToReturn, nugget, toArray, userMail, userData;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              valueToReturn = _this.state.value;
              nugget = _this.getNugget();
              toArray = [];

              if (nugget.feedbackEmail) {
                toArray = nugget.feedbackEmail.split(',');
              }

              if (!(nugget.sendToUser && _config["default"].userEmailPath)) {
                _context.next = 18;
                break;
              }

              userMail = _DataStore["default"].getElementByPathImmediately(_config["default"].userEmailPath);

              if (userMail) {
                _context.next = 17;
                break;
              }

              _context.next = 10;
              return _UserManagementService["default"].getUserFromAuthServer();

            case 10:
              userData = _context.sent;

              if (!(userData && userData.user && userData.user.additionalData)) {
                _context.next = 15;
                break;
              }

              _context.next = 14;
              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.USER_PROFILE, userData.user.additionalData);

            case 14:
              return _context.abrupt("return", _this.onClick());

            case 15:
              _context.next = 18;
              break;

            case 17:
              toArray.push(userMail);

            case 18:
              _this.props.markAsRead(_this.props.id);

              _this.setState({
                value: '',
                subjectValue: ''
              });

              if (!(toArray.length === 0)) {
                _context.next = 22;
                break;
              }

              return _context.abrupt("return", (0, _MuiAlertHelper.showAlertWithOptions)({
                message: (0, _DrupalNuggetStrings.getString)('NO_TO_MAILS_TEXT'),
                title: (0, _DrupalNuggetStrings.getString)('NO_TO_MAILS_TITLE')
              }));

            case 22:
              if (!_this.props.inFeedbackContainer) {
                _context.next = 26;
                break;
              }

              return _context.abrupt("return", {
                id: _this.props.id,
                type: 'feedback',
                data: {
                  title: nugget.title,
                  email: nugget.feedbackEmail,
                  value: valueToReturn
                }
              });

            case 26:
              console.log('Send an email to ' + nugget.feedbackEmail);
              _context.next = 29;
              return (0, _MailHelper.sendFeedbackMail)(toArray, null, null, null, "".concat(_config["default"].defaultNavbarTitle, " ").concat(_this.state.subjectValue ? "".concat(_this.state.subjectValue, " - ") : '', "Feedback"), valueToReturn);

            case 29:
              if (_this.props.closePrevDialogFn) {
                _this.props.closePrevDialogFn();
              }

              (0, _MuiAlertHelper.showAlertWithOptions)({
                message: (0, _DrupalNuggetStrings.getString)('FEEDBACK_MAIL_SEND_SUCCESS_TEXT'),
                title: (0, _DrupalNuggetStrings.getString)('FEEDBACK_MAIL_SEND_SUCCESS_TITLE')
              });

            case 31:
              _context.next = 36;
              break;

            case 33:
              _context.prev = 33;
              _context.t0 = _context["catch"](0);
              (0, _MuiAlertHelper.showAlertWithOptions)({
                message: (0, _DrupalNuggetStrings.getString)('FEEDBACK_MAIL_SEND_ERROR_TEXT', [_context.t0]),
                title: (0, _DrupalNuggetStrings.getString)('FEEDBACK_MAIL_SEND_ERROR_TITLE')
              });

            case 36:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 33]]);
    })));
    _this.state = _objectSpread({
      value: '',
      subjectValue: ''
    }, _this.state);

    _this.props.registerNugget(_this.props.id, _FeedbackNugget["default"].CLASS, _this.getDomId(), _this.props.inSwipeContainer || _this.props.inGalleryContainer || _this.props.inListContainer);

    _this.setDataStorePaths([_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES, _DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA]);

    return _this;
  }

  (0, _createClass2["default"])(DrupalFeedbackNugget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.registerNuggetPosition(this.props.id, _FeedbackNugget["default"].CLASS, this.getDomId()); // this.getIcsContents()

      if (this.props.inListContainer) {
        this.props.setBackButtonFunc(this.props.goUpFunc);
      }

      if (this.props.inFeedbackContainer) {
        this.props.registerSendFunc(this.props.id, this.onClick);
      }
    }
  }, {
    key: "getNugget",
    value: function getNugget() {
      return this.state.content[this.props.id];
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var nugget = this.getNugget();
      var active = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(this.props.id, ".").concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER))) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] || nugget.active : nugget.active;
      var innerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].innerHidden) : '';
      var outerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].outerHidden) : '';
      var likes = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_LIKES) || [];
      var likeIndex = likes.indexOf(this.props.id);
      var allLikes = this.state.data[_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES];
      var currentLikesForId = allLikes && allLikes["".concat(this.props.id)] ? allLikes["".concat(this.props.id)] : 0;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "feedbackContainer ".concat(this.props.inFeedbackContainer ? _DrupalFeedbackNugget["default"].feedbackContainerInContainer : _DrupalFeedbackNugget["default"].feedbackContainer, " ").concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobile', " ").concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer, " ").concat(outerClassNames),
        id: this.getDomId(),
        style: this.props.inSwipeContainer || this.props.inListContainer || this.props.inGalleryContainer ? {
          width: '100%',
          padding: 0,
          margin: 0
        } : {}
      }, _config["default"].showNuggetIcons && !this.props.inFeedbackContainer ? this.props.renderIcon(nugget) : null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, nugget.show_title ? /*#__PURE__*/_react["default"].createElement("div", {
        className: this.props.inGalleryContainer ? 'titleSmall' : 'title'
      }, nugget.title) : null, nugget.info ? /*#__PURE__*/_react["default"].createElement("div", {
        className: 'info',
        dangerouslySetInnerHTML: {
          __html: nugget.info
        }
      }) : null, nugget.showSubjectField ? /*#__PURE__*/_react["default"].createElement(StyledTextField, {
        value: this.state.subjectValue,
        InputProps: {
          disableUnderline: true
        },
        classes: {
          root: _DrupalFeedbackNugget["default"].textfield
        },
        margin: 'normal',
        label: (0, _DrupalNuggetStrings.getString)('FEEDBACK_SUBJECT_LABEL'),
        placeholder: (0, _DrupalNuggetStrings.getString)('FEEDBACK_SUBJECT_PLACEHOLDER'),
        onChange: this.handleSubjectChange,
        variant: 'outlined'
      }) : null, /*#__PURE__*/_react["default"].createElement(StyledTextField, {
        multiline: true,
        value: this.state.value,
        InputProps: {
          disableUnderline: true
        },
        classes: {
          root: _DrupalFeedbackNugget["default"].textfield
        },
        margin: 'normal',
        rows: 3,
        label: nugget.placeHolderText ? nugget.placeHolderText : (0, _DrupalNuggetStrings.getString)('FEEDBACK_TEXT_LABEL'),
        placeholder: nugget.placeHolderText ? nugget.placeHolderText : (0, _DrupalNuggetStrings.getString)('FEEDBACK_TEXT_PLACEHOLDER'),
        onChange: this.handleChange,
        variant: 'outlined'
      })), !this.props.inFeedbackContainer && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          paddingTop: '20px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_index["default"], {
        forcedColor: _config["default"].useTileBackgroundColorInTile ? this.props.forcedUIColor : _cssConstants["default"].colors.buttonBackground,
        className: _config["default"].useCenteredButtons ? _DrupalFeedbackNugget["default"].centeredButton : _DrupalFeedbackNugget["default"].button,
        onClick: this.onClick
      }, nugget.sendToUser ? (0, _DrupalNuggetStrings.getString)('SEND_NOTES_TO_ME_NOW') : (0, _DrupalNuggetStrings.getString)('SEND_NOW')))), _config["default"].hasLikeFunctionalityForNuggets && !this.props.inSwipeContainer && !this.props.inListContainer && !this.props.inGalleryContainer ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _Nugget["default"].likeContainer
      }, _config["default"].useTargetIcons ? /*#__PURE__*/_react["default"].createElement("img", {
        className: _Nugget["default"].svgLikeButton,
        onClick: function onClick() {
          return _this2.props.setLike();
        },
        src: likeIndex < 0 ? _config["default"].likeInactive : _config["default"].likeActive
      }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        onClick: function onClick() {
          return _this2.props.setLike();
        },
        className: likeIndex < 0 ? _Nugget["default"].likeButton : _Nugget["default"].likeButtonActivated,
        name: 'thumbs-o-up'
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Nugget["default"].likeText
      }, "".concat(currentLikesForId, " ").concat(currentLikesForId === 1 ? 'Like' : 'Likes'))) : null);
    }
  }]);
  return DrupalFeedbackNugget;
}(_KESI2BasicComponent["default"]);

DrupalFeedbackNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  goUpFunc: _propTypes["default"].func,
  renderIcon: _propTypes["default"].func.isRequired,
  inFeedbackContainer: _propTypes["default"].bool,
  registerSendFunc: _propTypes["default"].func,
  setLike: _propTypes["default"].func
};
DrupalFeedbackNugget.defaultProps = {
  id: null
};
var _default = DrupalFeedbackNugget;
exports["default"] = _default;